/**
 * Vanilla Next (vn) API
 *
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


export const DeliveryTimeRange = {
    ANY_TIME: 'ANY_TIME',
    AFTER: 'AFTER',
    BEFORE: 'BEFORE',
    ON_TIME: 'ON_TIME'
} as const;
export type DeliveryTimeRange = typeof DeliveryTimeRange[keyof typeof DeliveryTimeRange];

